<mat-tab-group>
  <mat-tab label="{{'Tabs.UploadStatus'| translate}}">
    <ng-template matTabContent>
      <app-upload [uploadId]="uploadId"></app-upload>
    </ng-template>
  </mat-tab>
  
</mat-tab-group>